import React from "react";
import { kitComponents, householdItems } from "../electronicsKitData";
import {
  BatteryCharging,
  PlugZap,
  Lightbulb,
  ShieldCheck,
  Volume2,
  ToggleRight,
  Cog,
  Fan,
  Rocket,
  Home,
  PackageCheck,
  Scissors,
} from "lucide-react";

const getComponentIcon = (iconName) => {
  switch (iconName) {
    case "battery-charging":
      return <BatteryCharging size={24} />;
    case "plug-zap":
      return <PlugZap size={24} />;
    case "lightbulb":
      return <Lightbulb size={24} />;
    case "shield-check":
      return <ShieldCheck size={24} />;
    case "volume-2":
      return <Volume2 size={24} />;
    case "toggle-right":
      return <ToggleRight size={24} />;
    case "cog":
      return <Cog size={24} />;
    case "fan":
      return <Fan size={24} />;
    case "rocket":
      return <Rocket size={24} />;
    default:
      return <PackageCheck size={24} />;
  }
};

const KitContentsSection = () => {
  return (
    <section className="section kit-contents-section" id="kit-contents">
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center reveal-triggered fade-up" data-aos="fade-up">
          <div className="section-badge">
            <PackageCheck size={16} /> Kit Inventory
          </div>
          <h2 className="section-title">What's in Your Kit?</h2>
          <p className="section-subtitle">
            Every part in your box is designed for quick, hands-on assembly with no soldering iron required.
          </p>
        </div>

        {/* 9 Kit Parts Grid */}
        <div className="parts-grid">
          {kitComponents.map((item, idx) => (
            <div
              key={item.id}
              className="part-card reveal-triggered zoom-in"
              data-aos="zoom-in"
              data-aos-delay={(idx % 3 + 1) * 100}
            >
              <div className="part-card-header">
                <div className="part-icon-badge" style={{ backgroundColor: `${item.color}15`, color: item.color }}>
                  {getComponentIcon(item.icon)}
                </div>
                <span className="part-badge" style={{ color: item.color, borderColor: `${item.color}40` }}>
                  {item.badge}
                </span>
              </div>
              <h3 className="part-name">{item.name}</h3>
              <p className="part-desc">{item.whatItDoes}</p>
            </div>
          ))}
        </div>

        {/* Household Items Panel */}
        <div className="household-box reveal-triggered fade-up" data-aos="fade-up" data-aos-delay="200">
          <div className="household-header">
            <div className="household-title-group">
              <div className="house-icon-wrapper">
                <Home size={22} />
              </div>
              <div>
                <h3>Things You Need From Home</h3>
                <p>Simple craft and desk supplies you can easily find around the house.</p>
              </div>
            </div>
            <div className="grownup-note">
              <Scissors size={18} />
              <span>Ask a grown-up to help with scissors and pins!</span>
            </div>
          </div>

          <div className="household-tags-grid">
            {householdItems.map((item, index) => (
              <div key={index} className="household-tag">
                <span className="dot-bullet"></span>
                <span>{item.name}</span>
              </div>
            ))}
          </div>

          <div className="household-footer-callout">
            <strong>Pro-Tip:</strong> Every project card below lists exactly which kit pieces and household crafts you
            will need before you begin.
          </div>
        </div>
      </div>
    </section>
  );
};

export default KitContentsSection;
